import React from "react";
import { Link } from "react-router-dom";
import aristiSS from "../../../assets/product-aristi.png";

const CallToAction = () => {
  const scrollHeader = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
  };
  return (
    <div className="aristi-call-to-action-wrapper">
      <div className="" id="callToAction">
        <div
          className="call-to-action-container text-center"
          style={{ backgroundImage: "url('../../assets/bg-pattern.svg')" }}
        >
          <div
            className="position-relative right-side-width"
            style={{ gap: "15px" }}
          >
            <h4 className="title_text">See Aristi in Action</h4>
            <p className="detail-info">
              Ready to discover how Aristi can transform your security access?
              Schedule a live demo and experience the power of a robust,
              user-friendly Multi-Factor Authentication solution.
            </p>
            <Link
              to="/connect-with-us"
              className="btn-md btn-dark border-0"
              onClick={scrollHeader}
            >
              Contact Us
            </Link>
          </div>
          <div className="image-container">
            <img src={aristiSS} alt="image" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;
